import { X } from "lucide-react";
import { useId, type ReactNode } from "react";
import { IconButton } from "./IconButton";
import { useOverlay } from "./useOverlay";

export function Drawer({
  eyebrow,
  title,
  leading,
  meta,
  children,
  onClose,
  closeLabel = "Fechar detalhes",
  className = "",
}: {
  eyebrow?: string;
  title: string;
  leading?: ReactNode;
  meta?: ReactNode;
  children: ReactNode;
  onClose: () => void;
  closeLabel?: string;
  className?: string;
}) {
  const titleId = useId();
  const drawerRef = useOverlay<HTMLElement>(onClose);

  return (
    <div
      className="lead-drawer-backdrop"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) onClose();
      }}
    >
      <aside
        ref={drawerRef}
        className={`lead-drawer ${className}`.trim()}
        role="dialog"
        aria-modal="true"
        aria-labelledby={titleId}
        tabIndex={-1}
      >
        <header className="lead-drawer__header">
          <div className="lead-drawer__identity">
            {leading}
            <div>
              {eyebrow && <span className="eyebrow">{eyebrow}</span>}
              <h2 id={titleId}>{title}</h2>
              {meta}
            </div>
          </div>
          <IconButton label={closeLabel} onClick={onClose}>
            <X />
          </IconButton>
        </header>
        <div className="lead-drawer__body">{children}</div>
      </aside>
    </div>
  );
}
